import { KsService, useApiClient } from '@siclop/kstone-vue'
import type { TeamMember } from '../models/Team'
import { ensureSuccess, deleteNoContent } from '@/shared/utils/apiResult'

interface MembreRequest {
  employeeId: number
  isManager: boolean
}

/** Équipes (`/teams`, T55) et leurs membres (`/teams/{id}/members` : lecture VIEW_TEAM, écriture EDIT_TEAM). */
export class TeamService extends KsService {
  protected static mainUrl = '/teams'

  static async getMembers(teamId: number): Promise<TeamMember[]> {
    return useApiClient().get<TeamMember[]>(`${this.mainUrl}/${teamId}/members`)
  }

  static async addMember(teamId: number, employeeId: number, isManager: boolean): Promise<TeamMember> {
    return useApiClient().postRaw<MembreRequest, TeamMember>(`${this.mainUrl}/${teamId}/members`, { employeeId, isManager })
  }

  static async setManager(teamId: number, member: TeamMember, isManager: boolean): Promise<TeamMember> {
    return useApiClient().putRaw<MembreRequest, TeamMember>(`${this.mainUrl}/${teamId}/members/${member.id}`,
      { employeeId: member.employeeId, isManager })
  }

  /** `DELETE` répond 204 : `deleteNoContent` (le client lirait le corps vide comme un échec), erreur levée sinon. */
  static async removeMember(teamId: number, memberId: number): Promise<void> {
    const result = await deleteNoContent(`${this.mainUrl}/${teamId}/members/${memberId}`, 'Erreur lors du retrait du membre')
    ensureSuccess(result, 'Erreur lors du retrait du membre')
  }
}
